import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '@/contexts/LanguageContext';

const Terms = () => {
  const { t } = useLanguage();

  return (
    <>
      <div className="min-h-screen py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-white rounded-xl shadow-lg p-8"
          >
            <h1 className="text-3xl font-bold text-gray-900 mb-6">
              {t('termsTitle')}
            </h1>
            <div className="prose max-w-none text-gray-600">
              <p>
                ברוכים הבאים ל-Printeam, אתר שמופעל על ידי <strong>א.ז. שירותי מחשוב ולוגיסטיקה</strong> (להלן: "החברה"). מסמך תנאי השימוש זה מגדיר את הכללים וההגבלות לשימוש באתר שלנו, הנמצא בכתובת printeam.co.il.
              </p>
              <p>
                באמצעות הגלישה והשימוש באתר אתם מסכימים לתנאי השימוש אלה במלואם. אם אינכם מסכימים עם תנאי השימוש, נא לא להמשיך ולשימוש באתר.
              </p>

              <h2 className="text-2xl font-semibold mt-6 mb-4">אודות בית העסק</h2>
              <p>
                האתר והפעילות המסחרית מופעלים על ידי <strong>א.ז. שירותי מחשוב ולוגיסטיקה</strong>.
                פעילות Printeam עוסקת בהתאמה אישית, מיתוג, הדפסה וייצור של פריטי לבוש ומוצרים
                ממותגים בהתאם לפרטי ההזמנה המאושרים על ידי הלקוח.
              </p>

              <h2 className="text-2xl font-semibold mt-6 mb-4">שימוש בעוגיות (Cookies)</h2>
              <p>
                האתר עושה שימוש בעוגיות כדי לשפר את חוויית המשתמש, לאסוף נתונים אנונימיים לניתוח ובכדי לאחסן בחירות תצוגה בסיסיות. לשימוש בעוגיות יש חשיבות לתפעול תקין של חלק מהשירותים.
              </p>

              <h2 className="text-2xl font-semibold mt-6 mb-4">קניין רוחני והגנה על זכויות יוצרים</h2>
              <p>
                כל התכנים, העיצובים, הלוגואים והחומרים המוצגים באתר הינם בבעלות Printeam או מורשים לשימוש על ידה, ומוגנים על ידי דיני זכויות יוצרים ו/או זכויות קניין רוחני אחרות.
              </p>
              <p>
                זכויות יוצרים והגנה: כל הזכויות שמורות. אין להעתיק, לשכפל, לשדר, להפיץ, להציג בפומבי או ליצור עבודות נגזרות מכל חלק מהחומרים באתר ללא אישור בכתב ובמפורש של Printeam. כל שימוש לא מורשה ייחשב להפרה וייעשה בו שימוש בכל האמצעים המשפטיים העומדים לרשות החברה, לרבות דרישה לנזקים והוצאת צו מניעה.
              </p>

              <h2 className="text-2xl font-semibold mt-6 mb-4">הגבלות שימוש</h2>
              <p>אי שימוש או שימוש אסור בתכנים האתר עלול להביא להשלכות משפטיות. בין הדברים שאינם מותרות:
              </p>
              <ul>
                <li>שכפול וחזרת פרסום של תכני האתר ללא הרשאה</li>
                <li>מכירה, השכרה או רישוי משנה של תכני האתר</li>
                <li>שימוש בתכנים למטרות מסחריות ללא אישור</li>
              </ul>

              <h2 className="text-2xl font-semibold mt-6 mb-4">התחלת ההסכם</h2>
              <p>תנאים אלה נכנסים לתוקף ממועד השימוש באתר וממשיכים להיות בתוקף כל עוד אתם משתמשים באתר.
              </p>

              <h2 className="text-2xl font-semibold mt-6 mb-4">מדיניות אחריות</h2>
              <p>
                החברה מתחייבת לאיכות הייצור בהתאם לפרטי ההזמנה שאושרו על ידי הלקוח. במקרה של
                פגם בייצור או טעות שמקורה בחברה, יש ליצור קשר עם החברה תוך 7 ימים ממועד קבלת
                המוצר, ולצרף מספר הזמנה, תיאור מפורט של הבעיה ותיעוד חזותי ברור.
              </p>
              <p>
                לאחר בדיקה ואימות, החברה תפעל לפי שיקול דעתה לתיקון, החלפה או החזר כספי,
                בהתאם לנסיבות המקרה.
              </p>

              <h2 className="text-2xl font-semibold mt-6 mb-4">מדיניות משלוחים וזמני אספקה</h2>
              <p>
                עלות המשלוח מחושבת באתר בהתאם לכמות הפריטים בהזמנה. איסוף עצמי ו/או משלוח
                יתבצעו בהתאם לאפשרות שנבחרה על ידי הלקוח בתהליך ההזמנה.
              </p>
              <p>
                זמני האספקה המוצגים באתר הם זמני אספקה משוערים. נכון לנוסח המוצג באתר, זמן
                האספקה המוצהר הוא 5–10 ימי עבודה ממועד אישור ההזמנה והגשת הקבצים, והזמנים
                עשויים להשתנות בעונות עמוסות, בהיקף ההזמנה, בזמינות חומרים ובאילוצי תפעול
                ושילוח.
              </p>

              <h2 className="text-2xl font-semibold mt-6 mb-4">מדיניות ביטולים</h2>
              <p>
                בהתאם להוראות חוק הגנת הצרכן, תשמ״א–1981, ולנוהג המקובל בענף הדפוס והייצור
                בהתאמה אישית, לא ניתן לבטל עסקה, להחזיר מוצר או לקבל החזר כספי עבור מוצרים
                שיוצרו או הוזמנו בהתאמה אישית ללקוח, לרבות מוצרים עם הדפסה, מיתוג, עיצוב ייחודי
                או כל שינוי לפי דרישת הלקוח.
              </p>
              <p>
                הזמנה של מוצר מותאם אישית נחשבת סופית ומחייבת מרגע אישורה, גם אם תהליך הייצור
                או ההדפסה טרם החל בפועל, ולא ניתן לבטלה מכל סיבה שהיא, לרבות שינוי דעת הלקוח,
                טעות בהזמנה, עיכוב בייצור או כל נסיבה אחרת שאינה באחריות החברה.
              </p>
              <p>
                חריג למדיניות זו יחול אך ורק במקרה של פגם בייצור או טעות שמקורה בחברה, בהתאם
                למדיניות האחריות המפורטת לעיל.
              </p>

              <h2 className="text-2xl font-semibold mt-6 mb-4">מדיניות פרטיות</h2>
              <p>
                החברה אוספת מידע שמספקים המשתמשים ישירות במסגרת שימוש באתר והזמנה, לרבות שם,
                טלפון, כתובת אימייל, כתובת למשלוח ופרטי הזמנה, וכן נתוני שימוש טכניים ונתונים
                אנונימיים כגון כתובת IP, סוג דפדפן, דפי כניסה ויציאה, לצורך תפעול האתר, עיבוד
                הזמנות, שירות לקוחות, ניתוח סטטיסטי, אבטחה ומניעת הונאות.
              </p>
              <p>
                מידע אישי לא יימסר לצדדים שלישיים אלא לצורך תפעול ההזמנה והשירות, כגון ספקי
                תשלום וחברות שילוח, או כאשר קיימת חובה לפי דין. החברה נוקטת באמצעי אבטחה
                מקובלים לשמירה על המידע, אך אין אפשרות להבטיח אבטחה מוחלטת בסביבה מקוונת.
              </p>

              <h2 className="text-2xl font-semibold mt-6 mb-4">פרטי בית העסק</h2>
              <p>
                האתר מופעל על ידי <strong>א.ז. שירותי מחשוב ולוגיסטיקה</strong>, האורגים 32, חולון.
                לפניות: <a href="mailto:info@printeam.co.il" className="text-blue-600 hover:underline">info@printeam.co.il</a> | 050-396-9640
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default Terms;
